import {Component} from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import Badge from 'react-bootstrap/lib/Badge';
import request from 'request-promise-native';
import LoadingModal from "../modals/LoadingModal";
import ValidatedFormComponent from "../ValidatedFormComponent";
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import YesNoDialog from "../modals/YesNoDialog";
import SuccessDialog from "../modals/SuccessDialog";
import FailedDialog from "../modals/FailedDialog";
import FormDialog from "../modals/FormDialog";
import Alert from "react-bootstrap/lib/Alert";

const GET_LICENSE_LIST = "https://flexa-license.azurewebsites.net/api/LicenseList";
const ADD_LICENSE = "https://flexa-license.azurewebsites.net/api/LicenseGenerate";
const ADD_COUPON = "https://flexa-license.azurewebsites.net/api/CouponGenerate";

const types = [
    {
        id: 0,
        name: "MDBToolchest"
    },
    {
        id: 1,
        name: "TwintDaemon"
    }
];

class ListLicensesTab extends Component {

    constructor(props) {
        /*
            Props:
             - access_code
             - logout
        */
        super(props);

        this.state = {
            addLicenseOpen: false,
            addingLicense: false,
            addLicenseSuccess: null,
            addLicenseFailed: null,

            addCouponOpen: false,
            addingCoupon: false,
            addCouponSuccess: null,
            addCouponFailed: null,

            licenses: null,
            loading: true,

            searchButton: true,

            //Ordering
            currentOrderParam: null,
            currentOrderDesc: false,

            tableLoading: false,
            pages: 1,
            page: 0
        };

        this.pageCache = null;

        this.currentSearch = null;
    }

    async fetchData(state,instance) {
        console.log("State: ",state);
        console.log("Instance: ",instance);

        const sort = state.sorted[0];
        if(sort.desc!==this.state.currentOrderDesc || sort.id!==this.state.currentOrderParam) {
            this.pageCache = null;
            this.currentOrderDesc = sort.desc;
            this.currentOrderParam = sort.id;
            this.setState({
                page: 0,
                currentOrderDesc: sort.desc,
                currentOrderParam: sort.id
            });
        }

        this.setState({
            tableLoading: true
        });

        if(this.pageCache==null) {
            const options = {
                method: 'POST',
                uri: GET_LICENSE_LIST,
                body: {
                    access_code: this.props.access_code,

                    orderDescending: sort.desc,
                    orderParam: sort.id,

                    search: this.currentSearch

                    //filterParam: this.state.currentSearch,
                    //filter: state.filter
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            if(response.statusCode!=200) {
                console.log('Logging out!');
                this.props.logout();
                return;
            }

            this.pageCache = [];
            this.pageCache[0] = response.body;

            console.log("Headers:",response);

            if(response.body[0]==null || response.body[0].last) {
                this.setState({
                    licenses: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 1
                });
            } else {
                this.setState({
                    licenses: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 2
                });
            }

            console.log("Cards request success");
        } else {
            if(this.pageCache[state.page]!=null) {
                this.setState({
                    licenses: this.pageCache[state.page],
                    tableLoading: false,
                    loading: false
                });
            } else {

                let lastSortedBy;

                if(this.pageCache[state.page-1]!=null) {
                    const page = this.pageCache[state.page-1];
                    console.log("Page: "+(state.page-1), page);
                    lastSortedBy = page[9][this.state.currentOrderParam];
                }
                console.log("Last sorted by '"+this.state.currentOrderParam+"': "+lastSortedBy);

                const options = {
                    method: 'POST',
                    uri: GET_LICENSE_LIST,
                    body: {
                        access_code: this.props.access_code,

                        lastSortedBy,

                        orderDescending: this.state.currentOrderDesc,
                        orderParam: this.state.currentOrderParam,

                        search: this.currentSearch

                        //filterParam: this.state.currentSearch,
                        //filter: state.filter
                    },
                    json: true,
                    resolveWithFullResponse: true,
                    simple: false
                };

                const response = await request(options);

                console.log("Headers:",response.headers);

                if(response.statusCode!=200) {
                    console.log('Logging out!');
                    this.props.logout();
                    return;
                }

                this.pageCache[state.page] = response.body;

                if(response.body[0]==null || response.body[0].last) {
                    this.setState({
                        licenses: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+1
                    });
                } else {
                    this.setState({
                        licenses: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+2
                    });
                }


                console.log("Cards request success");
            }
        }

    }

    resetTable() {
        this.pageCache = null;
        this.setState({
            page: 0
        },() => {
            this.fetchData.bind(this)({
                sorted: [
                    {
                        id: this.currentOrderParam,
                        desc: this.currentOrderDesc
                    }
                ]
            },null);
        });
    }

    async addLicense(serialId, typeId) {

        this.setState({
            addingLicense: true,
            addLicenseSuccess: null,
            addLicenseFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_LICENSE,
            body: {
                access_code: this.props.access_code,
                serialId,
                typeId
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                addLicenseSuccess: response.body.msg,
                addingLicense: false,
            });
            this.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addLicenseFailed: response.body,
            addingLicense: false,
        });

    }

    async addCoupon(count,typeId) {

        this.setState({
            addingCoupon: true,
            addCouponSuccess: null,
            addCouponFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_COUPON,
            body: {
                access_code: this.props.access_code,
                count,
                typeId
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                addCouponSuccess: (
                    <div>
                        {response.body.msg} Download them <a href={response.body.url}>here</a>!
                    </div>
                ),
                addingCoupon: false,
            });
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addCouponFailed: response.body,
            addingCoupon: false,
        });

    }

    render() {
        if(!this.props.open) return null;
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-book"></i> Licenses</h3>
                            <div className="ml-auto text-right">
                                <button className="btn btn-primary" onClick = {() => this.setState({addLicenseOpen: true})}>
                                    <i className="mdi mdi-plus font-16"></i>Add License
                                </button>
                                <button className="btn btn-cyan ml-2" onClick = {() => this.setState({addCouponOpen: true})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Coupons
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <FormDialog open={this.state.addLicenseOpen}
                            onClose={() => {
                                this.setState({
                                    addLicenseOpen:false,
                                    addLicenseFailed: null,
                                    addLicenseSuccess: null
                                })
                            }}
                            titleText="Add license"
                            submitText="Add license"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        return value==='' ? "Serial ID cannot be empty!" : null;
                                    },
                                    name: "Serial ID",
                                    type: "text",
                                    placeholder: "Enter device's serial ID"
                                },
                                {
                                    onValidate: (value) => {
                                        return null;
                                    },
                                    name: "Type",
                                    type: "select",
                                    options: types,
                                    value_key: "id",
                                    display_name_key: "name",
                                    placeholder: "Enter partner's e-mail"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const serialId = obj["Serial ID"];
                                const typeId = parseInt(obj["Type"]);
                                this.addLicense.bind(this)(serialId,typeId);
                            }}
                            notification={this.state.addLicenseSuccess ? (<Alert bsStyle="success"><strong>{this.state.addLicenseSuccess}</strong></Alert>) : this.state.addLicenseFailed ? (<Alert bsStyle="danger"><strong>{this.state.addLicenseFailed}</strong></Alert>) : ""}
                            loading={this.state.addingLicense}/>

                <FormDialog open={this.state.addCouponOpen}
                            onClose={() => {
                                this.setState({
                                    addCouponOpen:false,
                                    addCouponFailed: null,
                                    addCouponSuccess: null
                                })
                            }}
                            titleText="Add coupons"
                            submitText="Add coupons"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        return null;
                                    },
                                    name: "Count",
                                    type: "number",
                                    min: 1,
                                    max: 100,
                                    step: 1,
                                    placeholder: "Enter coupon count"
                                },
                                {
                                    onValidate: (value) => {
                                        return null;
                                    },
                                    name: "Type",
                                    type: "select",
                                    options: types,
                                    value_key: "id",
                                    display_name_key: "name",
                                    placeholder: "Enter partner's e-mail"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const count = parseInt(obj["Count"]);
                                const typeId = parseInt(obj["Type"]);
                                this.addCoupon.bind(this)(count,typeId);
                            }}
                            notification={this.state.addCouponSuccess ? (<Alert bsStyle="success"><strong>{this.state.addCouponSuccess}</strong></Alert>) : this.state.addCouponFailed ? (<Alert bsStyle="danger"><strong>{this.state.addCouponFailed}</strong></Alert>) : ""}
                            loading={this.state.addingCoupon}/>

                <div className="mt-4">
                    <Col sm={4} xs={8}>
                        <ValidatedFormComponent
                            type="text"
                            placeholder="Search"
                            onValidate={input => {
                                return null;
                            }}
                            inputRef={ref => this.searchRef=ref}
                            onChange={input => {
                                if(input==='' && this.currentSearch!=null) {
                                    this.setState({
                                        searchButton: false
                                    });
                                    return;
                                }

                                if(input!==this.currentSearch) {
                                    if(!this.state.searchButton) this.setState({
                                        searchButton: true
                                    })
                                }
                                if(input===this.currentSearch) {
                                    if(this.state.searchButton) this.setState({
                                        searchButton: false
                                    });
                                }
                            }}
                        />
                    </Col>
                    {this.state.searchButton ? (<Button bsStyle="success" onClick={() => {
                        if(this.searchRef.value!=='') {
                            if(this.currentSearch === this.searchRef.value) return;
                            this.setState({
                                searchButton: false
                            });
                            this.currentSearch = this.searchRef.value;
                            this.resetTable();
                        }
                    }}>
                        <i className="fa fa-search"/>
                    </Button>) : (<Button bsStyle="danger" onClick={() => {
                        if(this.currentSearch) {
                            this.currentSearch = null;
                            this.setState({
                                searchButton: true
                            });
                            this.resetTable();
                        }
                    }}>
                        <i className="fa fa-window-close"/>
                    </Button>)}

                </div>
                <div className="container-fluid">
                    <ReactTable
                        loading={this.state.tableLoading}
                        data={this.state.licenses==null ? [] : this.state.licenses}
                        /*getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='Delete' && column.Header!=="") return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        addDeviceOpen: true,
                                        editDevice: rowInfo.original
                                    });
                                }
                            };
                            return {};
                        }}*/
                        columns={[
                            {
                                Header: "License key",
                                accessor: "val",
                                maxWidth: 200
                            },
                            {
                                Header: "Device serial ID",
                                accessor: "serialId",
                                maxWidth: 250
                            },
                            {
                                Header: "Created",
                                accessor: "created",
                                maxWidth: 250,
                                Cell: (row) => {
                                    if(row.original.created) {
                                        return new Date(row.original.created).toLocaleString();
                                    }
                                }
                            },
                            {
                                Header: "Type",
                                sortable: false,
                                maxWidth: 150,
                                Cell: (row) => {
                                    if(row.original.deviceType===null || row.original.deviceType===undefined) {
                                        return (<Badge>Undefined</Badge>);
                                    } else {
                                        return (<Badge>{types[row.original.deviceType].name}</Badge>);
                                    }
                                }
                            },
                            {
                                Header: "Coupon used",
                                sortable: false,
                                maxWidth: 400,
                                Cell: (row) => {
                                    if(row.original.couponUsed==null || row.original.couponUsed==="Barix dashboard") {
                                        return (<Badge>Portal generated</Badge>)
                                    } else {
                                        return row.original.couponUsed;
                                    }
                                }
                            }
                        ]}
                        defaultSorted={[
                            {
                                id: "val",
                                desc: false
                            }
                        ]}
                        manual
                        pageText={""}
                        ofText={""}
                        pages={this.state.pages}
                        page={this.state.page}
                        onPageChange={(pageIndex) => this.setState({
                            page: pageIndex
                        })}
                        onFetchData={this.fetchData.bind(this)}
                        showPageJump={false}
                        showPageSizeOptions={false}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        collapseOnDataChange={false}
                    />
                </div>
            </div>
        );
    }
}

export default ListLicensesTab;